/* ============================================================================
 * THEME.JS — Shopify Theme JavaScript (formatted & annotated)
 * ----------------------------------------------------------------------------
 * This file was minified by the previous developer. Reformatted with prettier
 * and annotated with section comments to make navigation easier.
 *
 * NOTE on variable names: minifiers rename variables to single letters
 * (e, t, o, n, i, etc.) and reuse them in different scopes. Renaming them
 * automatically is risky, so the variables remain as-is. The most important
 * top-level aliases to know (in the BIG IIFE on ~line 70):
 *
 *     e  =  window.wetheme.$    (jQuery instance — read `e(...)` as `$(...)`)
 *     t  =  window.wetheme       (theme namespace — read `t.foo` as `wetheme.foo`)
 *
 * ============================================================================
 * TABLE OF CONTENTS
 * ============================================================================
 *
 *   SECTION 1   Quick Add — clear "disabled" from size swatches on load
 *   SECTION 2   Add-to-Cart enable/disable based on size-swatch selection
 *   SECTION 3   Headwear collection — hide size swatches entirely
 *   SECTION 4   MAIN THEME IIFE (the bulk of the code)
 *                 4a   Theme-editor block select/deselect handlers
 *                 4b   Section initializer: a(target)
 *                       - products-block       (masonry grid)
 *                       - slideshow            (flexslider)
 *                       - featured-blog        (owl carousel)
 *                       - text-adverts
 *                       - product-template     (images, reviews, recently viewed)
 *                       - product-recommendations
 *                       - indiv-product
 *                       - header               (nav, drawers, sticky, search/login)
 *                       - instagram feed
 *                       - collection-list      (hover fade)
 *                       - home-hero / video    (YouTube + Vimeo embeds)
 *                       - map                  (Google Maps)
 *                       - rellax parallax
 *                       - collection-template  (filters + pagination)
 *                       - featured-products
 *                 4c   Helper functions:
 *                       - s/c       scroll-reveal animations (WOW.js)
 *                       - l         hover fade for grid items
 *                       - d         sticky product summary
 *                       - u         non-ajax quantity selector +/-
 *                       - h         mobile product image carousel
 *                       - p / m     ProductSingle class (variant selector)
 *                       - f         tabs
 *                       - g / w     Shopify product reviews (SPR)
 *                       - y / _     sticky header
 *                 4d   Instagram feed: C, S
 *                 4e   Hero video: E (YouTube), k (Vimeo), L, T, I
 *                 4f   Hero overlay menu hover: $
 *                 4g   Slideshow class: P
 *                 4h   Rellax parallax: D
 *                 4i   Pagination class R (infinite scroll + load-more)
 *                 4j   Drawer base class z + Shop-now (j), Login (B), Search (V)
 *                 4k   Product image zoom: J, U, Y, Z
 *                 4l   Mobile review placeholder swap: K
 *                 4m   Text adverts carousel: ee
 *                 4n   Google Maps loader: ie, re, ae, gm_authFailure
 *                 4o   Public API: t.load_SPB_hide / load_SPB_show / load_all
 *
 *   SECTION 5   Collection filter IIFE (color/size/style/activity/fit/upf/fabrics)
 *               URL syncing + AJAX product grid reload
 *   SECTION 6   Mobile drawer open trigger
 *   SECTION 7   DrawerOverlay click handler
 *   SECTION 8   Mega-menu — open external links in new tab
 *
 * ============================================================================
 */



/* ====================================================================
 * SECTION 1: Quick Add — remove "disabled" class from size swatches
 *            inside .quick-add-to-cart blocks on window load.
 * ==================================================================== */

;(window.addEventListener("load", function () {
  document.querySelectorAll(".quick-add-to-cart .sizespanswt .size-swatch").forEach((e) => {
    e.classList.remove("active")
    e.classList.remove("disabled")
  })
}),

/* ====================================================================
 * SECTION 2: Add-to-Cart button state based on size-swatch selection.
 *  - 0 swatches  → enable button, mark <body> .no-size-swatch
 *  - 1 swatch    → enable + auto-select it, mark <body> .one-size-swatch
 *  - 2+ swatches → disable until user picks one (out-of-stock blocks it)
 *  Inner i(enable) flips the disabled state and the grey style.
 * ==================================================================== */

  document.addEventListener("DOMContentLoaded", function () {
    const e = document.querySelector(".add--to--cart"),
      t = document.querySelector(".sizespanswt"),
      o = t ? t.querySelectorAll(".size-swatch") : [],
      n = document.querySelector(".disabled-message")
    document.querySelectorAll(".quick-add-to-cart .sizespanswt .size-swatch").forEach((e) => {
      e.classList.remove("active")
      e.classList.remove("disabled")
    })
    if (e) {
      if (0 === o.length) return (document.body.classList.add("no-size-swatch"), void i(!0))
      if (1 === o.length)
        return (
          document.body.classList.add("one-size-swatch"),
          o[0].classList.add("active"),
          void i(!0)
        )
      ;(i(!1),
        document.addEventListener(
          "click",
          function (t) {
            if (e.disabled && t.target.closest(".add--to--cart"))
              return (t.preventDefault(), t.stopImmediatePropagation(), !1)
          },
          !0,
        ),
        o.forEach(function (e) {
          e.addEventListener("click", function () {
            (this.classList.contains("out-of-stock") || this.classList.contains("disabled"))
              ? i(!1)
              : (o.forEach((e) => e.classList.remove("active")),
                this.classList.add("active"),
                i(!0))
          })
        }))
    }
    function i(t) {
      t
        ? ((e.disabled = !1),
          e.classList.remove("disabled"),
          (e.style.backgroundColor = ""),
          (e.style.color = ""),
          n && (n.style.display = "none"))
        : ((e.disabled = !0),
          e.classList.add("disabled"),
          (e.style.backgroundColor = "#e6e6e6"),
          (e.style.color = "#a7a7a6"),
          n && (n.style.display = "block"))
    }
  }),

/* ====================================================================
 * SECTION 3: On /collections/headwear, hide size swatches and force-
 *            enable the add-to-cart button (headwear has no sizes).
 * ==================================================================== */

  document.addEventListener("DOMContentLoaded", function () {
    if (window.location.href.includes("/collections/headwear")) {
      document.querySelectorAll(".sizespanswt, .size-swatch").forEach((e) => {
        e.style.display = "none"
      })
      const e = document.querySelector(".add--to--cart")
      e && ((e.disabled = !1), e.classList.remove("disabled"))
      const t = document.querySelector(".disabled-message")
      t && (t.style.display = "none")
    }
  }),

/* ====================================================================
 * SECTION 4: MAIN THEME IIFE
 *   Called at the bottom as: (window.wetheme.$, window.wetheme)
 *   So inside this IIFE:
 *     e  =  jQuery (window.wetheme.$)
 *     t  =  wetheme namespace
 *
 *   Bound to Shopify theme-editor events (shopify:section:load/unload
 *   and shopify:block:select/deselect) so sections re-init in the editor.
 * ==================================================================== */

  (function (e, t) {
    var o = {}
    function i(t) {
      var n = o[t.detail.sectionId]
      if (n) {
        var i = parseInt(t.target.dataset.slideIndex)
        n.show_slide(i)
      }
      t.target.dataset.megaMenuBlockId &&
        (e("[data-mega-menu-block-id=" + t.target.dataset.megaMenuBlockId + "]")
          .closest("li.mega-menu")
          .addClass("force-open"),
        e(".overlay-header").addClass("force-hover"))
    }
    function r(t) {
      var n = o[t.detail.sectionId]
      ;(n && n.start_animation(),
        e("li.mega-menu.force-open").removeClass("force-open"),
        e(".overlay-header").removeClass("force-hover"))
    }
    ;(document.addEventListener("shopify:section:load", a),
      document.addEventListener("shopify:section:unload", function () {
        ;(document.removeEventListener("shopify:block:select", i),
          document.removeEventListener("shopify:block:deselect", r),
          (o = {}))
      }),
      window.addEventListener("load", a))
    try {
      ;(window.parent.messenger.on("stylesheetContent", a),
        window.addEventListener("unload", function () {
          window.parent.messenger.off("stylesheetContent", a)
        }))
    } catch (e) {}
    function a(t) {
      ;(document.addEventListener("shopify:block:select", i),
        document.addEventListener("shopify:block:deselect", r))
      var n,
        a,
        c,
        l,
        p,
        y,
        b = (function (e) {
          var t = null
          if (e && e.detail) {
            var o = {},
              n = e.target.dataset
            for (var i in n)
              n.hasOwnProperty(i) &&
                0 === i.indexOf("themeEditorSection-") &&
                (o = JSON.parse(n[i]))
            o.hasOwnProperty("type") && (t = o.type)
          }
          return t
        })(t)
      ;((b && "products-block" !== b) ||
        (n = e(".homepage-featured-products-grid").masonry({
          itemSelector: ".homepage-featured-grid-item",
          columnWidth: ".homepage-featured-grid-item",
          percentPosition: !0,
          gutter: ".gutter-sizer",
        }))
          .imagesLoaded()
          .progress(function () {
            n.masonry("layout")
          }),
        e(".blog-article-wrapper").masonry({
          itemSelector: ".blog-grid-item",
          columnWidth: ".blog-grid-item",
          gutter: ".blog-gutter-sizer",
          percentPosition: !0,
        }),
        (b && "slideshow" !== b) ||
          (function (t) {
            ;((o = {}), (t = t || document))
            var n = t.querySelectorAll(O)
            Array.prototype.forEach.call(n, function (t) {
              ;(e(t).find("li").css("width", e(t).width()), (o[t.dataset.sliderId] = new P(t)))
            })
          })(t && t.target),
        (b && "featured-blog" !== b) ||
          (e(".homepage-blog-mobile")
            .addClass("owl-carousel owl-theme")
            .owlCarousel({ items: 1, autoHeight: !0 }),
          e("#homepage-collection-mobile")
            .addClass("owl-carousel owl-theme")
            .owlCarousel({ items: 1, autoHeight: !0 })),
        (b && "text-adverts" !== b) || ee(),
        (b && "product-template" !== b) ||
          (h(),
          e("#shopify-product-reviews").length >= 0 && g(),
          J(),
          (function () {
            var t = e("#recently-viewed-products")
            if (t.hasClass("recently-viewed-loading")) return
            try {
              e.cookie("shopify_recently_viewed")
            } catch (e) {
              return void console.warn("Unable to read page cookies, blocked")
            }
            ;(t
              .empty()
              .removeClass("owl-carousel owl-theme owl-loaded owl-drag")
              .addClass("recently-viewed-loading"),
              Shopify.Products.showRecentlyViewed({
                howManyToShow: 10,
                onComplete: function () {
                  ;(e(".recently-viewed-products")
                    .fadeIn()
                    .find("#recently-viewed-products")
                    .addClass("owl-carousel owl-theme")
                    .owlCarousel({
                      loop: !1,
                      margin: 0,
                      nav: !0,
                      dots: !1,
                      navText: [
                        "<i class='fa fa-chevron-left'></i>",
                        "<i class='fa fa-chevron-right'></i>",
                      ],
                      responsive: { 0: { items: 2 }, 600: { items: 4 }, 1e3: { items: 4 } },
                    }),
                    window.SPR && window.SPR.loadBadges(),
                    G())
                },
              }),
              Shopify.Products.recordRecentlyViewed())
          })(),
          d()),
        (b && "product-recommendations" !== b) ||
          (function () {
            var t = document.querySelector(".product-recommendations")
            if (null === t) return
            var o = t.dataset.productId,
              n =
                "/recommendations/products?section_id=product-recommendations&limit=" +
                t.dataset.limit +
                "&product_id=" +
                o,
              i = new XMLHttpRequest()
            ;(i.open("GET", n),
              (i.onload = function () {
                if (i.status >= 600 && i.status < 700) {
                  var o = document.createElement("div")
                  ;((o.innerHTML = i.response),
                    (t.parentElement.innerHTML = o.querySelector(
                      ".product-recommendations",
                    ).innerHTML))
                }
                ;(e(".product-recommendations__slideshow")
                  .addClass("owl-carousel owl-theme")
                  .owlCarousel({
                    loop: !1,
                    margin: 0,
                    nav: !0,
                    dots: !1,
                    navText: [
                      "<i class='fa fa-chevron-left'></i>",
                      "<i class='fa fa-chevron-right'></i>",
                    ],
                    responsive: { 0: { items: 2 }, 600: { items: 4 }, 1e3: { items: 4 } },
                  }),
                  window.Currency &&
                    window.Currency.convertAll(
                      window.Currency.shopCurrency,
                      window.Currency.currentCurrency,
                    ))
              }),
              i.send())
          })(),
        (b && "indiv-product" !== b) ||
          ((a = e(".homepage-sections--indiv-product-slider")).flexslider({
            directionNav: !1,
            slideshow: !1,
            animation: "slide",
          }),
          a.find("img").removeClass("hide"),
          w()),
        (b && "product-template" !== b && "indiv-product" !== b) || (u(), m(t.target), f()),
        (b && "header" !== b) ||
          (e(".site-nav").addClass("js"),
          e(".site-nav li a").focus(function () {
            e(this).parent().children("ul").fadeIn()
          }),
          e(".site-nav li li a").off(),
          e(".mobile-nav__link").on("click", function () {
            this.href &&
              this.href.split("#")[0] === window.location.href.split("#")[0] &&
              timber.LeftDrawer.close()
          }),
          d(),
          _(),
          e(".log-in-button").off("click", F).on("click", F),
          e(".search-button").off("click", W).on("click", W),
          e(document.body).on("afterGetCart.ajaxCart", function (t, o) {
            e(".cart-item-count-header--quantity").text(o.item_count)
            var n = e(".cart-item-count-header--total")
            if (n.length > 0) {
              var i = Shopify.formatMoney(
                o.total_price,
                window.Currency
                  ? window.Currency.moneyFormats[window.Currency.shopCurrency].money_format
                  : window.default_currency_format,
              )
              ;(n.html('<span class="money">' + i + "</span>"),
                window.Currency &&
                  window.Currency.convertAll(
                    window.Currency.shopCurrency,
                    window.Currency.currentCurrency,
                  ))
            }
          })),
        (c = document.querySelectorAll(v)),
        Array.prototype.forEach.call(c, S),
        (b && "collection-list" !== b) ||
          (l = e(".homepage-collection-grid-item")).on("mouseenter mouseleave", function (e) {
            l.not(this)
              .stop(!0)
              .fadeTo("fast", "mouseenter" == e.type ? 0.2 : 1)
          }),
        (b && "products-block" !== b) ||
          (function () {
            var t = e(".homepage-featured-products-grid").masonry({
              itemSelector: ".homepage-featured-grid-item",
              columnWidth: ".homepage-featured-grid-item",
              percentPosition: !0,
              gutter: ".gutter-sizer",
            })
            t.imagesLoaded().progress(function () {
              t.masonry("layout")
            })
          })(),
        (b && "home-hero" !== b && "video" !== b) ||
          ((function () {
            if (!document.querySelector(".homepage-hero-youtube-video")) return
            window.YT
              ? E()
              : document.querySelector("#youtube_api") ||
                ((window.onYouTubePlayerAPIReady = E),
                I("youtube_api", "https://www.youtube.com/player_api"))
          })(),
          (function () {
            if (!document.querySelector(".homepage-hero-vimeo-video")) return
            if (document.querySelector("#vimeo_api")) window.Vimeo && k()
            else {
              var e = I("vimeo_api", "https://player.vimeo.com/api/player.js")
              e.readyState
                ? (e.onreadystatechange = function () {
                    ;("loaded" != element.readyState && "complete" != element.readyState) ||
                      ((element.onreadystatechange = null), k())
                  })
                : (e.onload = function () {
                    k()
                  })
            }
          })()),
        (b && "home-hero" !== b) ||
          e(".homepage-hero-content-overlay-menu-item").imagesLoaded(
            { background: !0 },
            function () {
              ;(e(".homepage-hero-text-advert-link").each(function (t, o) {
                $(e(o))
              }),
                e(".homepage-hero-menu li").each(function (t, o) {
                  $(e(o))
                }))
            },
          ),
        (b && "map" !== b && "page-contact-template" !== b) ||
          (function () {
            var t = document.querySelectorAll(te)
            if (0 === t.length) return
            var o = null
            if (
              (Array.prototype.forEach.call(t, function (e) {
                var t = e.dataset.id,
                  n = document.querySelector("#apikey-" + t).value
                n &&
                  (o && n && n !== o
                    ? console.warn(
                        "Multiple different Google Maps API keys are not allowed, using only the first one",
                      )
                    : (o = n))
              }),
              !o)
            )
              return (
                console.error("Google Maps API key not provided!"),
                void ie("Google Maps API key not provided!", null)
              )
            !oe &&
            window.google &&
            window.google.maps &&
            window.google.maps.Geocoder &&
            window.google.maps.Map
              ? window.google_maps_loaded()
              : ((oe = !1),
                e.getScript(
                  "https://maps.googleapis.com/maps/api/js?key=" +
                    o +
                    "&callback=google_maps_loaded",
                ))
          })(),
        (b &&
          "feature-row" !== b &&
          "image-with-text-overlay" !== b &&
          "collection-template" !== b &&
          "page-contact-template" !== b &&
          "list-collections-template" !== b) ||
          (function () {
            if (0 === document.querySelectorAll(".rellax").length) return
            e(window).width() <= 768 ? !0 : setTimeout(D.bind(null, !0), 100)
            q && window.removeEventListener(q)
            q = window.addEventListener("resize", function () {
              for (var t in N)
                if (N.hasOwnProperty(t)) {
                  N[t].destroy()
                }
              ;((N = {}),
                setTimeout(function () {
                  D(e(window).width() > 768)
                }, 100))
            })
          })(),
        (b && "collection-template" !== b) ||
          ((p = e(".coll-filter")).on("change", function () {
            var t = []
            if (
              (p.each(function () {
                var o = e(this).val()
                o && t.push(o)
              }),
              t.length)
            ) {
              var o = t.join("+"),
                n = e("#link-to-tag-generic a").attr("href").replace(/\+/g, "%20")
              window.location.href = n.replace(/(\/|=)tag($|\?|&)/, "$1" + o + "$2")
            } else window.location.href = e("#link-to-collection").val()
          }),
          e(".collection-filter-tag-checkbox").on("change", function () {
            var t = Array.prototype.map
                .call(
                  document.querySelectorAll("input.collection-filter-tag-checkbox:checked"),
                  function (e) {
                    return e.value
                  },
                )
                .join("+"),
              o = e("#link-to-tag-generic a").attr("href").replace(/\+/g, "%20")
            window.location.href = o.replace(/(\/|=)tag($|\?|&)/, "$1" + t + "$2")
          }),
          (function () {
            M && (M.uninstall_scroll_handler(), (M = null))
            var t = e(".pagination-infinite"),
              o = e(".pagination--load-more")
            if (0 === t.length && 0 === o.length) return
            M = new R()
          })(),
          w()),
        (b && "featured-products" !== b) || w(),
        (b &&
          "collection-template" !== b &&
          "featured-products" !== b &&
          "product-template" !== b &&
          "list-collections-template" !== b &&
          "product-recommendations" !== b) ||
          G(),
        b
          ? s()
          : ((y = 0),
            e(document.body)
              .off("beforeDrawerOpen.timber")
              .on("beforeDrawerOpen.timber", function () {
                "fixed" !== e(document.body).css("position") &&
                  ((y = e(window).scrollTop()), d(), _())
              }),
            e(document.body)
              .off("beforeDrawerClose.timber")
              .on("beforeDrawerClose.timber", function () {
                ;(e(document.body).css({
                  position: "static",
                  height: "auto",
                  width: "auto",
                  overflow: "auto",
                  marginTop: "0",
                }),
                  e(window).scrollTop(y),
                  d(),
                  _())
              })),
        e("#DrawerOverlay")
          .off("click")
          .on("click", function (e) {
            ;(timber.LeftDrawer.drawerIsOpen &&
              (timber.LeftDrawer.close(), e.stopImmediatePropagation()),
              timber.RightDrawer.drawerIsOpen &&
                (timber.RightDrawer.close(), e.stopImmediatePropagation()))
          }),
        e(document).on("keyup", function (e) {
          27 == e.keyCode &&
            timber.RightDrawer.drawerIsOpen &&
            (timber.RightDrawer.close(), e.stopImmediatePropagation())
        }))
      var C = e(".search-button").length > 0
      ;(e(".input-group.search-bar").toggle(C),
        document.body.classList.add("loaded"),
        window.addEventListener("beforeunload", function () {
          document.body.classList.add("unloading")
        }))
    }
    function s() {
      ;(e(window).on("scroll", function () {
        c()
      }),
        c(),
        new WOW().init())
    }
    function c() {
      var t = e(window).height()
      e(".show-on-scroll").each(function (o, n) {
        var i = n.getBoundingClientRect()
        i.bottom >= 0 &&
          i.top < t &&
          e(n).removeClass("show-on-scroll").addClass("shown-on-scroll1")
      })
    }
    function l(t, o) {
      var n = e(t).find(o)
      n.on("mouseenter mouseleave", function (e) {
        n.not(this)
          .stop(!0)
          .fadeTo("fast", "mouseenter" === e.type ? 0.2 : 1)
      })
    }
    function d() {
      var t = e(".product-sticky.ui.sticky")
      if (0 !== t.length) {
        var o = e(window)
        if ((i(), e(window).on("resize", i), e("#shopify-product-reviews").length >= 0))
          var n = setInterval(function () {
            var t = e(".spr-summary-actions-newreview")
            0 !== t.length &&
              (clearInterval(n),
              t.on("click", function () {
                i()
              }))
          }, 1e3)
      }
      function i() {
        if (o.width() > 768 && e(".context").height() > t.height()) {
          var n = e(".site-header"),
            i = 0
          ;(n.hasClass("sticky-header") && (i = n.outerHeight() || 0),
            t.sticky({ context: ".context", offset: i, bottomOffset: 50, observeChanges: !0 }))
        }
      }
    }
    function u() {
      var t = e(".nonajax-quantity-selector")
      if (0 !== t.length) {
        var o = t.find("input")
        ;(t.find(".js-qty__adjust--minus").on("click", function () {
          o.val(Math.max(1, parseInt(o.val()) - 1))
        }),
          t.find(".js-qty__adjust--plus").on("click", function () {
            o.val(parseInt(o.val()) + 1)
          }))
      }
    }
    function h() {
      var t = e("#product-images-mobile")
      if (0 !== t.length) {
        var o,
          i = t.closest("#ShopNowContainer").length > 0
        ;((o = i
          ? { center: !0, items: 2, autoHeight: !0, dots: !0 }
          : { items: 1, autoHeight: !0 }),
          t.owlCarousel(o),
          i &&
            e(document).on("click", "#product-images-mobile .owl-item", function () {
              ;((n = e(this).index()), e("#product-images-mobile").trigger("to.owl.carousel", n))
            }),
          (function (t) {
            t.on("refreshed.owl.carousel changed.owl.carousel", function (t) {
              e("#product-images-mobile .owl-dots").each(function (t, o) {
                e(o).children().length > 1 && e(o).removeClass("disabled")
              })
            })
          })(t),
          (function (t) {
            t.on("refreshed.owl.carousel", function (o) {
              e(this)
                .delay(500)
                .queue(function () {
                  1 == e(".owl-stage-outer", t).height() &&
                    e(".owl-stage-outer", t).css({ height: "auto" })
                })
            })
          })(t))
      }
    }
    function p(t) {
      if (((this.element = t), this.element)) {
        ;((this.$element = e(this.element)), (this.sectionId = this.element.dataset.sectionId))
        var o = document.querySelector("#ProductJson-" + this.sectionId)
        o &&
          ((this.product = JSON.parse(o.innerText)),
          (this.$selects = this.$element.find(".selector-wrapper select")),
          this.$selects.on("change", this.on_select_change.bind(this)),
          (this.$original_select = this.$element.find(".original-select")),
          (this.thumbnail_changes_variant =
            "true" === this.$element.find("#thumbnail_changes_variant").val()),
          (this.$main_image = this.$element.find(".product-single__photo")),
          (this.$main_image_wrapper = this.$main_image.closest(".product-single__photo-wrapper")),
          (this.$thumbnails = this.$element.find(".product-single__thumbnail-wrapper")),
          this.$thumbnails.on(
            "click",
            function (e) {
              ;(e.preventDefault(), this.on_thumbnail_click(e.currentTarget, !0))
            }.bind(this),
          ),
          this.on_select_change())
      }
    }
    function m(e) {
      var t = e || document
      Array.prototype.forEach.call(t.querySelectorAll(".product-single"), function (e) {
        new p(e)
      })
    }
    function f() {
      e("ul.tabs").each(function () {
        var t,
          o,
          n = e(this).find("a")
        ;((t = n.first().addClass("active")),
          (o = e(t.attr("href"))),
          n.not(":first").each(function () {
            e(e(this).attr("href")).hide()
          }),
          e(this)
            .find("a")
            .click(function (n) {
              return (
                t.removeClass("active"),
                o.hide(),
                (t = e(this)),
                (o = e(e(this).attr("href"))),
                t.addClass("active"),
                o.fadeIn(),
                !1
              )
            }))
      })
    }
    function g() {
      var e = setInterval(function () {
        window.SPR &&
          window.SPR.$ &&
          (clearInterval(e),
          window.SPR.initDomEls(),
          window.SPR.loadProducts(),
          window.SPR.loadBadges())
      }, 500)
    }
    function w() {
      e("#shopify-product-reviews-badge").length >= 0 && g()
    }
    function y() {
      var t = e(".sticky-header"),
        o = Math.max(t.first().outerHeight(!0), t.last().outerHeight(!0))
      t.parent().innerHeight(o)
    }
    function _(t) {
      e(".sticky-header").sticky({ observeChanges: !0, context: "body", silent: !0 })
      var o = e(".site-header__logo-image img")
      ;(t
        ? y()
        : o.imagesLoaded(function () {
            _(!0)
          }),
        e(window).off("resize", y).on("resize", y))
    }
    ;(e(document).ready(function () {
      s()
    }),
      (p.prototype.on_select_change = function () {
        var t = this.$selects.map(function (t, o) {
            return e(o).val()
          }),
          o = this.product.variants.filter(function (e) {
            for (var o = 0; o < t.length; o++) if (t[o] !== e.options[o]) return !1
            return !0
          })
        0 === o.length ? this.update_variant(null) : this.update_variant(o[0])
      }),
      (p.prototype.on_thumbnail_click = function (t, o) {
        var n = e(t),
          i = n.attr("href"),
          r = this.$main_image.attr("src"),
          a = i.replace("{width}x", "300x")
        if (r !== a) {
          var s = n
            .find("img")
            .clone()
            .attr("src", a)
            .attr("data-src", i.replace("{width}x", "{width}"))
            .removeClass("product-single__thumbnail")
            .addClass("product-single__photo fadeLazyload lazyload")
            .css("max-width", n.find("img").data("max-width") + "px")
            .data("imageZoomEnable", this.$main_image.data("imageZoomEnable"))
            .prop("id", this.$main_image.prop("id"))
          ;(this.$main_image.replaceWith(s), (this.$main_image = s))
        }
        if (
          (this.$main_image_wrapper.trigger("zoom.destroy").find(".zoomImg").remove(),
          U(),
          this.thumbnail_changes_variant && o)
        ) {
          var c = e(t).data("variant")
          c && this.on_variant_selected(c)
        }
      }),
      (p.prototype.on_variant_selected = function (t) {
        var o = this.product.variants.filter(function (e) {
          return e.id == t
        })
        if (0 === o.length) this.update_variant(null)
        else {
          var n = o[0]
          this.update_variant(o[0])
          for (var i = 0; i < n.options.length; i++)
            e("#SingleOptionSelector-" + i).val(n.options[i])
        }
      }),
      (p.prototype.update_variant = function (t) {
        if (
          (timber.productPage({
            money_format: window.Currency
              ? window.Currency.moneyFormats[window.Currency.shopCurrency].money_format
              : window.default_currency_format,
            variant: t,
            element: this.$element,
          }),
          t)
        ) {
          if (t.featured_image) {
            var o = this.$element.find(
              '.product-single__thumbnail[data-image-id="' + t.featured_image.id + '"]',
            )
            o.length > 0 && this.on_thumbnail_click(o.parent().parent(), !1)
          }
          this.$original_select.val(t.id)
          var n = e(this.element)
              .closest(".shopify-section")
              .hasClass("homepage-section--indiv-product-wrapper"),
            i = this.product.variants.length > 1
          if (history.replaceState && !n && i) {
            var r = []
            ;(window.location.search.length > 1 &&
              (r = window.location.search
                .slice(1)
                .split("&")
                .filter(function (e) {
                  return 0 !== e.indexOf("variant=")
                })),
              r.push("variant=" + t.id))
            var a =
              window.location.protocol +
              "//" +
              window.location.host +
              window.location.pathname +
              "?" +
              r.join("&")
            window.history.replaceState({ path: a }, "", a)
          }
          var s = t.compare_at_price && t.compare_at_price > t.price
          ;(e(this.element).closest(".product-page--sale-badge").toggleClass("hide", !s),
            e(".product-details-wrapper").data("show-sku") &&
              (e(".js__currentVariantSKU").text(t.sku),
              e(".product__meta--sku").toggleClass("hide", !t.sku)))
          var c = window.Currency
            ? window.Currency.moneyFormats[window.Currency.shopCurrency].money_format
            : window.default_currency_format
          ;(t.unit_price && t.unit_price_measurement
            ? (e(".unit-price").removeClass("hide"),
              e(".unit-price__price").html(
                '<span class="money">' + Shopify.formatMoney(t.unit_price, c) + "</span>",
              ),
              e(".unit-price__ref-value").html(t.unit_price_measurement.reference_value),
              e(".unit-price__ref-unit").html(t.unit_price_measurement.reference_unit),
              window.Currency.convertAll(
                window.Currency.shopCurrency,
                window.Currency.currentCurrency,
              ))
            : e(".unit-price").addClass("hide"),
            e(".out-of-stock-form").length &&
              (function (t) {
                setTimeout(function () {
                  if (t && void 0 !== t.available)
                    if (t.available)
                      (e("#notify-me").stop(!0, !0).hide(),
                        e(".out-of-stock-form").removeClass("out-of-stock-form--active"),
                        e("#notify-me-wrapper").removeClass("show-form"),
                        e('#notify-me-wrapper input[name="contact[body]"]').val(""))
                    else {
                      ;(e("#notify-me").stop(!0, !0).fadeIn(),
                        e(".out-of-stock-form").addClass("out-of-stock-form--active"),
                        e("#notify-me a")
                          .off("click")
                          .on("click", function (t) {
                            ;(t.preventDefault(),
                              "0" == e(".logged-in").val()
                                ? e(".out-of-stock-form form").submit()
                                : e("#notify-me-wrapper").addClass("show-form"))
                          }))
                      var o = "Please notify me when " + t.name + " becomes available."
                      e('#notify-me-wrapper input[name="contact[body]"]').val(o)
                    }
                }, 300)
              })(t))
        }
      }),
      (window.wetheme.$.fn.tmpl = function (t) {
        Handlebars.registerHelper("formatMoney", function (e) {
          return Shopify.formatMoney(
            e,
            window.Currency
              ? window.Currency.moneyFormats[window.Currency.shopCurrency].money_format
              : window.default_currency_format,
          )
        })
        var o = Handlebars.compile(this.text()),
          n = t.featured_image
        return (
          n || (n = e(".recently-viewed-products").data("no-image-url")),
          e.extend(t, {
            responsiveImage: Shopify.Products.resizeImage(n, "{width}"),
            imageSrc: Shopify.Products.resizeImage(n, "medium"),
            sale: t.compare_at_price_max > t.price && t.available,
            sold_out: !t.available,
            id: t.id,
          }),
          window.Currency &&
            setTimeout(function () {
              window.Currency.convertAll(
                window.Currency.shopCurrency,
                window.Currency.currentCurrency,
              )
            }, 10),
          window.wetheme.$(o(t))
        )
      }))
    var v = ".instagram-wrapper",
      b =
        '<div class="grid__item  homepage-instagram-indiv">    <a href="" target="_blank">        <img            src=""            data-src=""            data-srcset=""            data-sizes="auto"            class="lazyload instagram-image"        />        <div class="homepage-instagram-hover">            <span class="fa-stack fa-2x">                <i class="fa fa-circle fa-stack-2x fa-inverse"></i>                <i class="fa fa-instagram fa-stack-1x"></i>            </span>        </div>    </a></div>'
    function C(t, o, n, i) {
      e.getJSON({ url: t + "&callback=?", crossDomain: !0, dataType: "jsonp" })
        .then(function (e) {
          return (
            e.data.forEach(function (e) {
              o.length >= n || ("image" === e.type && o.push(e))
            }),
            o.length < n && e.pagination && e.pagination.next_url
              ? C(e.pagination.next_url, o, n, i)
              : i(o, null)
          )
        })
        .catch(function (e) {
          var t
          try {
            t = e.responseJSON.meta.error_message
          } catch (e) {
            t = "Unknown error"
          }
          return i(o, t)
        })
    }
    function S(t) {
      var o = t.dataset.id,
        n = document.querySelector("#token-" + o)
      if (n) {
        var i = n.value,
          r = document.querySelector("#instafeed-" + o),
          a = r.dataset.gridWidth,
          s = parseInt(r.dataset.rows) * parseInt(r.dataset.grid),
          c = Handlebars.compile(b),
          d = e(r)
        C(
          "https://api.instagram.com/v1/users/self/media/recent?access_token=" + i + "&count=1000",
          [],
          s,
          function (t, o) {
            if (o) {
              if (Shopify.designMode) {
                ;(d.empty(),
                  d.css("position", "relative"),
                  e('<div class="instagram-container-error"></div>').text(o).appendTo(d))
                for (
                  var n = document.querySelector("#instagram-placeholder").textContent, i = 0;
                  i < s;
                  i++
                )
                  e(n).appendTo(d)
              } else d.closest(".instagram-section-wrapper").hide()
              console.error("Unable to load instagram data:", o)
            } else
              (d.empty(),
                d.closest(".instagram-section-wrapper").show(),
                t.forEach(function (t) {
                  var o = t.images
                  e(
                    c({
                      link: t.link,
                      grid: a,
                      image_thumb: o.thumbnail.url,
                      srcset:
                        o.thumbnail.url +
                        " " +
                        o.thumbnail.width +
                        "w, " +
                        o.low_resolution.url +
                        " " +
                        o.low_resolution.width +
                        "w," +
                        o.standard_resolution.url +
                        " " +
                        o.standard_resolution.width +
                        "w",
                    }),
                  ).appendTo(d)
                }),
                l(d[0], ".grid__item"))
          },
        )
      } else l(t, ".grid__item")
    }
    function E() {
      e(".homepage-hero-youtube-video").each(function (e, t) {
        !(function (e) {
          var t = "true" === e.dataset.homepageHeroVideoAutoplay,
            o = "true" === e.dataset.homepageHeroVideoMute,
            n = "true" === e.dataset.homepageHeroVideoLoop
          player = new YT.Player(e.id, {
            width: 746,
            videoId: e.dataset.homepageHeroVideoLink,
            playerVars: { showinfo: 0, modestbranding: 1, rel: 0, autoplay: t ? 1 : 0 },
            events: {
              onReady: function (n) {
                var i = document.getElementById(e.id)
                ;(o && (n.target.mute(), t && n.target.playVideo()),
                  t && T(i),
                  L(i, "youtube", n.target))
              },
              onStateChange: function (e) {
                e.data === YT.PlayerState.ENDED && n && e.target.playVideo()
              },
            },
          })
        })(t)
      })
    }
    function k() {
      e(".homepage-hero-vimeo-video").each(function (e, t) {
        !(function (e) {
          var t = new Vimeo.Player(e.id)
          t.ready()
            .then(function () {
              ;(L(e, "vimeo", t),
                "true" === document.querySelector("#" + e.id).dataset.vimeoAutoplay && T(e),
                "true" === document.querySelector("#" + e.id).dataset.homepageHeroVideoMute &&
                  t.setVolume(0))
            })
            .catch(function (t) {
              document.getElementById(e.id).innerText = t
            })
        })(t)
      })
    }
    function L(t, o, n) {
      var i = t.closest(".homepage-hero-content--video")
      i &&
        e(".homepage-video-play-button", i).on("click", function (e) {
          ;("youtube" === o ? n.playVideo() : "vimeo" === o && n.play(), T(t))
        })
    }
    function T(t) {
      var o = t.closest(".homepage-hero-content--video")
      ;(e(".js__hide-on-play", o).fadeOut("slow"),
        e(".homepage-hero-content-overlay-wrapper", o).addClass("overlay-hidden"))
    }
    function I(e, t) {
      var o = document.createElement("script")
      ;((o.id = e), (o.src = t))
      var n = document.getElementsByTagName("script")[0]
      return (n.parentNode.insertBefore(o, n), o)
    }
    function $(t) {
      var o = e("#" + t.data("overlayId"))
      ;(t.hover(
        function () {
          o.addClass("active")
        },
        function () {
          o.removeClass("active")
        },
      ),
        t.is(":hover") && o.addClass("active"))
    }
    var A = { directionNav: !0, controlNav: !0, startAt: 0 },
      O = ".flexslider-homepage",
      x = 6e3
    function P(t) {
      ;((this.$element = e(t)),
        (this.restartTimer = null),
        (this.running = !0),
        (this.get_speed = function () {
          return parseInt(this.$element.data("sliderSlideTime"))
        }),
        (this.get_animation = function () {
          return this.$element.data("sliderAnimation")
        }),
        (this.show_slide = function (e) {
          ;(this.get_speed() > 0 && this.$element.flexslider("stop"),
            (this.running = !1),
            this.$element.flexslider(e))
        }),
        (this.start_animation = function () {
          ;((this.running = !0), this.get_speed() > 0 && this.$element.flexslider("play"))
        }),
        (this.on_slide_change = function (e) {
          ;((speed = this.get_speed()),
            this.running &&
              !e.playing &&
              speed > 0 &&
              (clearTimeout(this.restartTimer),
              (this.restartTimer = setTimeout(
                function () {
                  e.play()
                },
                Math.max(0, x - speed),
              ))))
        }),
        (this.configure = function (t) {
          var o = this.get_speed(),
            n = this.$element.parent().find(".custom-navigation"),
            i = e.extend(
              {
                controlsContainer: n,
                slideshowSpeed: o,
                animation: this.get_animation(),
                slideshow: o > 0,
                useCSS: !1,
                pauseOnAction: !0,
                after: this.on_slide_change.bind(this),
                customDirectionNav: n.find("a"),
              },
              A,
              t,
            )
          this.$element.flexslider(i)
        }),
        this.configure({}),
        e(window).off("blur"))
    }
    var N = {},
      q = null
    function D(e) {
      Array.prototype.forEach.call(document.querySelectorAll(".rellax"), function (t) {
        var o, n
        ;((t.style.transform = "translate3d(0,0,0)"),
          e &&
            ((o = t.id),
            (n = N[o]) && n.destroy(),
            (N[o] = new Rellax("#" + o, { center: !0, speed: -4 }))))
      })
    }
    function R() {
      ;((this.PAGINATION_LOAD_OFFSET = 1200),
        (this.SCROLL_DELAY = 200),
        (this.PAGINATION_SELECTOR = ".pagination"),
        (this.COLLECTION_MAIN_SELECTOR = ".collection-main-body-inner"),
        (this.COLLECTION_HEADER_SELECTOR = ".collection-main-central-header"),
        (this.COLLECTION_ITEM_SELECTOR = ".grid__item"),
        (this.COLLECTION_ITEM_EXCLUDE_SELECTOR = ".collection-central-description-block"),
        (this.$w = e(window)),
        (this.$doc = e(document)),
        (this.$self = this),
        (this.$collection = e(this.COLLECTION_MAIN_SELECTOR)),
        (this.$loading_indicator = e(".pagination-loading")),
        (this.loading = !1),
        (this.fully_loaded = !1),
        (this.scroll_timeout = null),
        (this.pagination_type = null),
        (this.scroll_handler = this.scroll_handler.bind(this)),
        (this.check_infinite_scroll = this.check_infinite_scroll.bind(this)),
        this.initialize())
    }
    ;((R.prototype.initialize = function () {
      e(".pagination").hasClass("pagination-infinite")
        ? ((this.pagination_type = "infinite-scroll"), this.install_scroll_handler())
        : e(".pagination").hasClass("pagination--load-more") &&
          ((this.pagination_type = "load-more"), this.load_more_button())
    }),
      (R.prototype.install_scroll_handler = function () {
        e(window).on("scroll", this.scroll_handler)
      }),
      (R.prototype.uninstall_scroll_handler = function () {
        e(window).off("scroll", this.scroll_handler)
      }),
      (R.prototype.scroll_handler = function () {
        ;(this.scroll_timeout && clearTimeout(this.scroll_timeout),
          (this.scroll_timeout = setTimeout(this.check_infinite_scroll, this.SCROLL_DELAY)))
      }),
      (R.prototype.check_infinite_scroll = function () {
        this.$doc.height() - this.PAGINATION_LOAD_OFFSET <
          this.$doc.scrollTop() + this.$w.height() && this.load_next_page()
      }),
      (R.prototype.check_pagination_progress = function () {
        var t = e(this.PAGINATION_SELECTOR).find(".pagination-next a").attr("href")
        this.fully_loaded = !t || "#" === t
      }),
      (R.prototype.build_load_more_html = function () {
        var t = parseInt(e(".pagination").attr("data-paginate-items"), 10),
          o =
            parseInt(e(".pagination").attr("data-paginate-offset"), 10) +
            parseInt(e(".pagination").attr("data-paginate-size"), 10)
        return (
          '<div class="pagination__load-more"><p class="pagination__progress-text">You\'ve viewed ' +
          o +
          " of " +
          t +
          ' products</p><div class="progress-bar"><div class="progress-bar__inner" style="width:' +
          (100 * o) / t +
          '%;"></div></div><button class="btn btn--large btn--load-more">Load more</button></div>'
        )
      }),
      (R.prototype.load_more_button = function () {
        this.check_pagination_progress()
        var t = 0 !== e(".pagination .btn--load-more").length,
          o = this.build_load_more_html()
        ;(t || this.fully_loaded || e(".pagination").append(o),
          e(".btn--load-more").off("click").on("click", this.load_next_page.bind(this.$self)))
      }),
      (R.prototype.set_loading = function (t) {
        t
          ? ((this.loading = !0),
            this.$loading_indicator.show(),
            e(this.PAGINATION_SELECTOR).hide())
          : ((this.loading = !1),
            this.$loading_indicator.hide(),
            e(this.PAGINATION_SELECTOR).show())
      }),
      (R.prototype.load_next_page = function () {
        if (this.loading) return !1
        var t = e(this.PAGINATION_SELECTOR).find(".pagination-next a").attr("href")
        t && "#" !== t
          ? (this.set_loading(!0),
            e
              .ajax({ type: "GET", url: t, dataType: "html" })
              .then(this.page_loaded.bind(this))
              .always(this.set_loading.bind(this, !1)))
          : this.uninstall_scroll_handler()
      }),
      (R.prototype.page_loaded = function (t) {
        var o = e(t),
          n = e("#grid_item_width_classes").val()
        ;(n &&
          o
            .find(".grid__item")
            .removeClass(
              "large--one-quarter medium--one-quarter small--one-whole large--one-half medium--one-half",
            )
            .addClass(n),
          this.$collection.append(
            o
              .find(this.COLLECTION_HEADER_SELECTOR + " > " + this.COLLECTION_ITEM_SELECTOR)
              .not(this.COLLECTION_ITEM_EXCLUDE_SELECTOR),
            o.find(this.COLLECTION_MAIN_SELECTOR + " > " + this.COLLECTION_ITEM_SELECTOR),
          ),
          e(this.PAGINATION_SELECTOR).replaceWith(o.find(this.PAGINATION_SELECTOR)),
          "load-more" === this.pagination_type && this.load_more_button(),
          G(),
          w())
      }))
    var M = null
    function z(t, o) {
      ;((this.animation_duration = 800),
        (this.$body = e("body")),
        (this.$drawer = e("#CartDrawer")),
        (this.$primary_container = e("#CartContainer")),
        (this.$primary_title = e("#CartTitle")),
        (this.$secondary_container = e(t)),
        (this.$secondary_title = e(o)),
        (this.$primary_group = this.$primary_container.add(this.$primary_title)),
        (this.$secondary_group = this.$secondary_container.add(this.$secondary_title)))
    }
    function j(t) {
      ;((this.$body = e("body")),
        (this.drawer = new z("#ShopNowContainer", "#ShopNowTitle")),
        this.$body.on("afterAddItem.ajaxCart", this.animate_to_cart.bind(this)),
        e
          .ajax({ type: "GET", url: t, dataType: "html" })
          .then(this.page_loaded.bind(this))
          .catch(function (e) {
            alert(e)
          }))
    }
    function H(t) {
      return (new j(e(this).attr("href")), !1)
    }
    function G() {
      e(".shop-now-button").off("click", H).on("click", H)
    }
    function B(t) {
      ;((this.drawer = new z("#LogInContainer", "#LogInTitle")),
        (this.$body = e("body")),
        e
          .ajax({ type: "GET", url: t, dataType: "html" })
          .then(this.page_loaded.bind(this))
          .catch(function (e) {
            alert(e)
          }))
    }
    function F(t) {
      return (new B(e(this).attr("href")), !1)
    }
    function V() {
      ;((this.drawer = new z("#SearchContainer", "#SearchTitle")),
        this.drawer.set_content_type("search"),
        this.drawer.open(),
        e("#search-input").focus(),
        (this.section_by_type = { article: "Articles", page: "Pages", product: "Products" }),
        (this.current_xhr = null),
        (this.onchange_timer = null),
        (this.$results = e("#search-results")))
      var t = e("#LiveSearchResultTemplate").html()
      ;((this.template = Handlebars.compile(t)), (this.storedAry = []))
      var o = (function (e) {
        let t = e + "=",
          o = document.cookie.split(";")
        for (let e = 0; e < o.length; e++) {
          let n = o[e]
          for (; " " == n.charAt(0); ) n = n.substring(1)
          if (0 == n.indexOf(t)) return n.substring(t.length, n.length)
        }
        return ""
      })("billfishsiteName")
      ;("" != o && (this.storedAry = JSON.parse(o)),
        console.log(this.storedAry),
        this.storedAry.length > 0 &&
          this.storedAry.forEach(function (t) {
            e("#search-data").append(
              "<a href=https://billfishgear.com/search?q=" + t + ">" + t + "</a>",
            )
          }))
      var n = this
      ;((n.lastQ = null),
        e("#search-input").on("keyup change", function () {
          if (e(this).val().length > 2) {
            var t = e(this).val()
            t !== n.lastQ && (n.onchange(t), (n.lastQ = t))
          }
        }))
    }
    function W(e) {
      return (new V(), !1)
    }
    function J() {
      ;(U(),
        e(window).on("resize", function () {
          U()
        }))
    }
    function U() {
      e(window).width() > 768
        ? e(".product-single__photo-wrapper img.product-single__photo")
            .off("mouseenter")
            .off("mouseleave")
            .removeProp("hoverIntent_t")
            .removeProp("hoverIntent_s")
            .hoverIntent(Y, Z)
        : e(".product-single__photo").each(function (t, o) {
            e(o).trigger("zoom.destroy")
          })
    }
    ;((z.prototype.show_primary = function () {
      ;(this.$secondary_group.addClass("hide"), this.$primary_group.removeClass("hide"))
    }),
      (z.prototype.show_secondary = function () {
        ;(this.$primary_group.addClass("hide"), this.$secondary_group.removeClass("hide"))
      }),
      (z.prototype.open = function () {
        ;(this.show_secondary(),
          this.$body.one("afterDrawerClose.timber", this.close.bind(this)),
          timber.RightDrawer.open())
      }),
      (z.prototype.set_content_type = function (e) {
        this.$drawer
          .removeClass("drawer--cart drawer--log-in drawer--show-now drawer--search")
          .addClass("drawer--" + e)
      }),
      (z.prototype.close = function () {
        setTimeout(
          function () {
            ;(this.show_primary(), this.set_content_type("cart"))
          }.bind(this),
          this.animation_duration,
        )
      }),
      (j.prototype.page_loaded = function (t) {
        var o = e(t),
          n = o.find(".product-single")
        ;(n.find("#shopify-product-reviews").remove(),
          n.find(".product-single__photos").hide(),
          n.find("#product-images-mobile").removeClass("large--hide"))
        var i = this.drawer.$secondary_container
        ;(i.find(".product-single").remove(),
          i.append(n),
          i.find("#ProductJson-product-template").remove(),
          i.append(o.find("#ProductJson-product-template")),
          u(),
          h(),
          m(i[0]),
          f(),
          Shopify.PaymentButton && Shopify.PaymentButton.init && Shopify.PaymentButton.init(),
          "undefined" != typeof ajaxCart &&
            ajaxCart.init({
              formSelector: "#AddToCartForm",
              cartContainer: "#CartContainer",
              addToCartSelector: "#AddToCart",
              cartCountSelector: "#CartCount",
              moneyFormat: window.Currency
                ? window.Currency.moneyFormats[window.Currency.shopCurrency].money_format
                : window.default_currency_format,
            }),
          this.drawer.set_content_type("show-now"),
          this.drawer.open())
      }),
      (j.prototype.animate_to_cart = function () {
        this.$body.one(
          "afterCartLoad.ajaxCart",
          function () {
            ;(timber.RightDrawer.close(),
              setTimeout(
                function () {
                  ;(this.drawer.show_primary(),
                    this.drawer.set_content_type("cart"),
                    timber.RightDrawer.open(),
                    this.drawer.$drawer.scrollTop(0))
                }.bind(this),
                this.drawer.animation_duration,
              ))
          }.bind(this),
        )
      }),
      (B.prototype.page_loaded = function (t) {
        var o = e(t).find(".main-content")
        ;(o.find(".login-form-cancel").remove(),
          o.find(".sitewide--title-wrapper").remove(),
          this.drawer.$secondary_container.empty().append(o),
          timber.cacheSelectors(),
          timber.loginForms(),
          this.drawer.set_content_type("log-in"),
          this.drawer.open())
      }),
      (V.prototype.onchange = function (e) {
        ;(this.onchange_timer && clearTimeout(this.onchange_timer),
          (this.onchange_timer = setTimeout(this.onchange_throttled.bind(this, e), 800)),
          this.current_xhr && this.current_xhr.abort())
      }),
      (V.prototype.get_search_url = function (e, t) {
        var o = ""
        return (t && (o = "&view=json"), "/search?type=product" + o + "&q=" + encodeURIComponent(e))
      }),
      (V.prototype.onchange_throttled = function (t) {
        var o = this.get_search_url(t, !0)
        ;(this.$results.empty(),
          this.$results.append(
            '<i class="fa fa-circle-o-notch fa-spin fa-fw"></i><span class="sr-only">Loading...</span>',
          ),
          (this.current_xhr = e.getJSON(o)),
          this.current_xhr.done(this.show_results.bind(this)),
          this.current_xhr.fail(this.show_error.bind(this)),
          this.current_xhr.always(
            function () {
              this.current_xhr = null
            }.bind(this),
          ))
      }),
      (V.prototype.show_results = function (t) {
        ;(this.storedAry.length >= 3 && this.storedAry.shift(),
          this.storedAry.push(t.terms),
          (function (e, t, o) {
            const n = new Date()
            n.setTime(n.getTime() + 24 * o * 60 * 60 * 1e3)
            let i = "expires=" + n.toUTCString()
            document.cookie = e + "=" + t + ";" + i + ";path=/"
          })("billfishsiteName", JSON.stringify(this.storedAry), 365),
          e("#search-data").append(
            "<a href=https://billfishgear.com/search?q=" + t.terms + ">" + t.terms + "</a>",
          ))
        var o = e("#search-show-more")
        ;(o.addClass("hide"), this.$results.empty())
        var n = {}
        if (
          (t.results.forEach(function (e) {
            n.hasOwnProperty(e.type) ? n[e.type].push(e) : (n[e.type] = [e])
          }),
          t.terms)
        )
          if (t.results.length > 0) {
            for (var i in (this.$results.append(
              "<p>" + SearchTranslations.results_for_html.replace("", t.terms) + "</p>",
            ),
            n))
              n.hasOwnProperty(i) &&
                (this.$results.append("<h2>" + this.section_by_type[i] + "</h2>"),
                n[i].forEach(this.show_result.bind(this)))
            ;(t.has_more && o.removeClass("hide").attr("href", this.get_search_url(t.terms, !1)),
              window.Currency &&
                window.Currency.convertAll(
                  window.Currency.shopCurrency,
                  window.Currency.currentCurrency,
                ))
          } else
            this.$results.append(
              "<p>" + SearchTranslations.no_results_html.replace("", t.terms) + "</p>",
            )
      }),
      (V.prototype.show_result = function (e) {
        this.$results.append(this.template(e))
      }),
      (V.prototype.show_error = function (t) {
        if ("abort" !== t.statusText) {
          ;(console.error("statusText", t.statusText), console.error("error", JSON.stringify(t)))
          var o = e("#search-input").val()
          window.location = this.get_search_url(o, !1)
        }
      }),
      e(document).ready(function () {
        J()
      }))
    function Y(t) {
      var o = e(this),
        n = o.data().imageZoomEnable,
        i = o.hasClass("js__image_already_loaded"),
        r = o.hasClass("js__smallImage")
      if (1 == n && !i && !r) {
        o.css({ opacity: 0.5 })
        var a = o.data().imageZoom,
          s = o.closest(".product-single__photo-wrapper"),
          c = s.find("#featured-image-loader").fadeIn("fast")
        s.zoom({
          url: a,
          callback: function () {
            ;(o.addClass("js__image_already_loaded"),
              c.fadeOut("slow"),
              o.trigger("mouseover"),
              o.css({ opacity: 1 }))
          },
          onZoomIn: function () {
            var e = s.find(".zoomImg")
            e.width() <= o.width()
              ? (o.css({ opacity: 1 }), e.css("visibility", "hidden"))
              : e.css("visibility", "visible")
          },
        })
      }
    }
    function Z() {
      e(this).css({ opacity: 1 })
    }
    if (e("#shopify-product-reviews").length > 0) {
      var Q = e(".desktop_review_placeholder"),
        X = e("#shopify-product-reviews", Q).clone()
      ;(K(X),
        e(window).on("resize", function () {
          K(X)
        }))
    }
    function K(t) {
      e(window).width() < 768
        ? e(".mobile_review_placeholder").append(t)
        : e(".mobile_review_placeholder #shopify-product-reviews").remove()
    }
    function ee() {
      e(".text-advert-section").length > 0 &&
        e(".text-advert-section .slides")
          .addClass("owl-carousel owl-theme")
          .owlCarousel({ items: 1, autoHeight: !0 })
    }
    ee()
    var te = ".map-wrapper",
      oe = !1,
      ne = []
    function ie(t, o) {
      ;(o || (o = e(".map-section__container")),
        o.addClass("hide"),
        Shopify.designMode &&
          e('<div class="map-container-error"></div>')
            .text(t)
            .appendTo(o.parent().find(".map-section__overlay")),
        o.parent().find(".homepage-map--fallback").removeClass("hide"))
    }
    function re() {
      ne.forEach(function (e) {
        var t = e.getCenter()
        ;(google.maps.event.trigger(e, "resize"), e.setCenter(t))
      })
    }
    function ae(t) {
      var o = t.dataset.id,
        n = (t.dataset.colors, [])
      try {
        n = JSON.parse(document.getElementById("homepage-map--theme--" + o).textContent)
      } catch (e) {
        console.error("Unable to parse theme style:", e)
      }
      var i = document.querySelector("#map-container-" + o)
      if (i) {
        var r = e(i)
        oe && ie("Google Maps authentication error, API key might be invalid", r)
        var a = new google.maps.Map(i, {
          zoom: 14,
          styles: n,
          disableDefaultUI: !0,
          draggable: !1,
          clickableIcons: !1,
          scrollwheel: !1,
          disableDoubleClickZoom: !0,
        })
        ;(ne.push(a),
          (function (t, n) {
            var i = e("#map-container-" + o).data("address-setting")
            t.geocode({ address: i }, function (e, t) {
              if ("OK" === t) {
                n.setCenter(e[0].geometry.location)
                new google.maps.Marker({ map: n, position: e[0].geometry.location })
              } else ie("Error looking up that address", r)
            })
          })(new google.maps.Geocoder(), a))
      }
    }
    ;((window.google_maps_loaded = function () {
      ;(Array.prototype.forEach.call(document.querySelectorAll(te), ae),
        e(window).off("resize", re).on("resize", re))
    }),
      (window.gm_authFailure = function () {
        ;((oe = !0), console.error("Authentication Failure"))
        e(".map-section__container")
        ie("Google Maps authentication error, API key might be invalid", null)
      }),
      (t.load_SPB_hide = function () {
        ;(e(".shopify-payment-button").hide(),
          e("#ShopNowContainer #AddToCart").addClass("full-width-button"))
      }),
      (t.load_SPB_show = function () {
        ;(e(".shopify-payment-button").show(),
          e("#ShopNowContainer #AddToCart").removeClass("full-width-button"))
      }),
      (t.load_all = a))
  })(window.wetheme.$, window.wetheme),
  (function () {
    var e = "#product-grid-container",
      t = 'input[type="checkbox"]',
      o = "#SortBy, #SortByMobile"
    function n() {
      var e = {},
        o = []
      ;(document.querySelectorAll("a.color-swatch.color-swatch--active").forEach(function (e) {
        var t = e.getAttribute("href").split("/").pop()
        t && o.push(t.replace("color-", ""))
      }),
        (o = Array.from(new Set(o))).length && (e.color = o))
      var n = []
      return (
        document.querySelectorAll("a.size-swatch.size-swatch--active").forEach(function (e) {
          var t = e.getAttribute("href").split("/").pop()
          t && n.push(t.replace("size-", ""))
        }),
        (n = Array.from(new Set(n))).length && (e.size = n),
        document.querySelectorAll(t + ":checked").forEach(function (t) {
          var o = t.id,
            n = null
          ;(o.startsWith("style-")
            ? (n = "style")
            : o.startsWith("activity-")
              ? (n = "activity")
              : o.startsWith("fit-")
                ? (n = "fit")
                : o.startsWith("upf-")
                  ? (n = "upf")
                  : o.startsWith("fabrics-") && (n = "fabrics"),
            n && (e[n] || (e[n] = []), e[n].push(t.labels[0].textContent.trim())))
        }),
        Object.keys(e).forEach(function (t) {
          e[t] = Array.from(new Set(e[t]))
        }),
        e
      )
    }
    function i(e) {
      var t = []
      return (
        Object.keys(e).forEach(function (o) {
          e[o].length &&
            t.push(encodeURIComponent(o) + "=" + e[o].map(encodeURIComponent).join(","))
        }),
        t.length ? "?" + t.join("&") : ""
      )
    }
    function r() {
      var e = window.location.pathname.split("/"),
        t = e.indexOf("collections")
      return -1 !== t && e.length > t + 1
        ? "/collections/" + e[t + 1]
        : window.location.pathname.split("?")[0]
    }
    function a(t) {
      var o = document.querySelector(e)
      if (o) {
        o.innerHTML = '<div class="loading">Loading products...</div>'
        var n = r()
        fetch(n + t)
          .then(function (e) {
            return e.text()
          })
          .then(function (t) {
            var n = new DOMParser().parseFromString(t, "text/html").querySelector(e)
            ;((o.innerHTML = n
              ? n.innerHTML
              : '<div class="empty-state"><p>No products found in this collection with the selected filters.</p></div>'),
              c())
          })
      }
    }
    function s(e) {
      e.preventDefault()
      var t = i(n())
      ;(!(function (e) {
        var t = r() + e
        window.history.pushState({ path: t }, "", t)
      })(t),
        a(t))
    }
    function c() {
      var e = document.querySelector(".collection-filters") || document.body
      ;(e.removeEventListener("click", l),
        e.addEventListener("click", l),
        document.querySelectorAll(t).forEach(function (e) {
          ;(e.removeEventListener("change", s), e.addEventListener("change", s))
        }),
        document.querySelectorAll(o).forEach(function (e) {
          ;(e.removeEventListener("change", s),
            e.addEventListener("change", function (e) {
              s(e)
            }))
        }))
    }
    function l(e) {
      ;(e.target.matches("a.color-swatch") &&
        (e.preventDefault(), e.target.classList.toggle("color-swatch--active"), s(e)),
        e.target.matches("a.size-swatch") &&
          (e.preventDefault(), e.target.classList.toggle("size-swatch--active"), s(e)))
    }
    ;(window.addEventListener("popstate", function () {
      a(i(n()))
    }),
      document.addEventListener("DOMContentLoaded", function () {
        c()
      }))
  })(),
  $(".icon-fallback-text.site-nav__link.js-drawer-open-left-link").on("click", function () {
    $("#DrawerOverlay").css("display", "block")
  }),
  $("#DrawerOverlay").on("click", function () {
    ;($("html").removeClass("js-drawer-open-left"),
      $("body").removeClass("js-drawer-open-left"),
      $(this).css("display", "none"))
  }),
  document.addEventListener("DOMContentLoaded", function () {
    document
      .querySelectorAll("#cstm_megamenu_container_megamenu-blocks .menudiv a")
      .forEach(function (e) {
        const t = e.getAttribute("href")
        t &&
          t.startsWith("http") &&
          !t.includes(window.location.hostname) &&
          (e.setAttribute("target", "_blank"), e.setAttribute("rel", "noopener noreferrer"))
      })
  }))